import { COLORS } from "../hooks/useAudioRecorder";

/**
 * Page wrapper that fills the viewport with the dark theme background
 * (full window width, even when content is centered in a narrow column on
 * wide screens) and renders children inside a centered max-width column.
 *
 * Use as the outermost element of any page that previously combined
 * `minHeight: 100dvh` + `backgroundColor` + `maxWidth` on the same div —
 * that pattern leaves white viewport gutters on wide screens.
 */
export default function PageShell({
  children,
  maxWidth = 540,
  padding = "20px 18px 28px",
  testId,
  fullBleed = false,
}) {
  return (
    <div
      data-testid={testId}
      style={{
        minHeight: "100dvh",
        backgroundColor: COLORS.bg,
        color: COLORS.text,
        fontFamily: "'Inter', system-ui, sans-serif",
        WebkitTapHighlightColor: "transparent",
      }}
    >
      <div
        style={
          fullBleed
            ? { width: "100%", padding, boxSizing: "border-box" }
            : { maxWidth, margin: "0 auto", padding, boxSizing: "border-box" }
        }
      >
        {children}
      </div>
    </div>
  );
}
